import { z } from "zod";
import { meetingTypeCode } from "./bookingMeetingTypes";
import { slotTime } from "./bookingSlots";

export const bookingAppointmentInputAnswer = z.object({
  questionCodeOrId: z.string(),
  answer: z.string(),
});

export type BookingAppointmentInputAnswer = z.infer<
  typeof bookingAppointmentInputAnswer
>;

export const bookingAppointmentInput = z.object({
  name: z.string(),
  email: z.string(),
  phone: z.string(),
  meetingTypeCode,
  date: z.iso.date(), // yyyy-MM-dd
  slotTime, // HH:mm
  answers: z.array(bookingAppointmentInputAnswer),
});

export type BookingAppointmentInput = z.infer<typeof bookingAppointmentInput>;
